/* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { ReactElement, useMemo } from 'react';
import {
  SchedulingProviderValueType,
  initStateDataValue,
  defaultSchedulingState
} from './SchedulingProvider.helpers';

/* ******************* The provider component ******************* */

const context =
  React.createContext<SchedulingProviderValueType>(initStateDataValue);

const renderProviderComponent = (children: ReactElement, stateRecord: any) => {
  const contextValue = useMemo(
    () => ({
      stateRecord
    }),
    [stateRecord]
  );

  return <context.Provider value={contextValue}>{children}</context.Provider>;
};

type SchedulingProviderCompProps = {
  children: ReactElement;
};
const SchedulingProviderComp = ({
  children
}: SchedulingProviderCompProps): ReactElement => {
  const schedulingStateRecord = defaultSchedulingState;

  return renderProviderComponent(children, schedulingStateRecord);
};

export const SchedulingProvider = SchedulingProviderComp;

export const SchedulingContext = context;
